/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ItemId, TreeSourcePosition } from './ItemId.types.tsx';
import { treeItemDataPrivateKey } from './treeItemDataPrivateKey.constants.tsx';
import type { TreeItemData } from './TreeItemData.types.tsx';

export const getTreeItemData = (
	data: Omit<TreeItemData, typeof treeItemDataPrivateKey>,
): {
	id: ItemId;
	type: string;
	parentId: ItemId;
	index: number;
	hasChildren: boolean;
	path: TreeSourcePosition[];
	[treeItemDataPrivateKey]: boolean;
} => ({
	[treeItemDataPrivateKey]: true,
	...data,
});

export const isTreeItemData = (data: Record<string | symbol, unknown>): data is TreeItemData =>
	Boolean(data[treeItemDataPrivateKey]);
